<template>
  <div id="widget-flash-message">
    <!-- <input type="hidden" id="ajax_flash_message" name="ajax_flash_message" value="<?php echo URL::route('flashmessage.get'); ?>"> -->
    <div class="ajax-flash-message">
      <div class="flash-message message-warning">
        <i class="icon-error fa fa-warning"></i>
        <span class="flash-message-text"></span>
        <div class="flash-message-close">x</div>
      </div>
    </div>
    <template v-if="responseMessage">
      <template v-if="typeof responseMessage == 'String'">
        <div class="flash-message message-warning">
          <i class="icon-error fa fa-warning"></i>
          {{ responseMessage }}
          <div class="flash-message-close">x</div>
        </div>
      </template>
      <template v-else>
        <div class="flash-div">
          <template v-if="responseMessage && responseMessage.status == 'success'">
            <div class="flash-message message-success">
              <i class="icon-error fa fa-check"></i>
              {{ responseMessage.message }}
              <div class="flash-message-close">x</div>
            </div>
          </template>
          <template v-if="responseMessage && responseMessage.status == 'error'">
            <div class="flash-message message-error">
              <i class="icon-error fa fa-times"></i>
              {{ responseMessage.message }}
              <div class="flash-message-close">x</div>
            </div>
          </template>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  name: 'widget-flash-message',
  props: {
    response: [ String, Object ]
  }
}
</script>


// WEBPACK FOOTER //
// WidgetFlashMessage.vue?82c5e3c6